var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navigation-list-template',{attrs:{"loading":_vm.loading,"items":_vm.studNavigationItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }